const TermsConditions = () => {
  return (
    <>
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Terms and Conditions
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              I hereby provide consent to use my mobile number for Insurance related matters by PINC Insurance & partners. They will be sharing my mobile number & official email ID with Insurer, surveyors or any relevant third party for Insurance purposes only. They will also be calling on this number to follow for any Insurance related activities.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TermsConditions;
